<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="label"
        :error-messages="errorMessages"
        :hide-details="hideDetails"
        :dense="dense"
        :outlined="outlined"
        :clearable="clearable"
        :hint="hint"
        :persistent-hint="persistentHint"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        @input="$emit('input', $event)"
        @keydown.enter="$emit('enter', $event)"
      />
    </template>
    <v-date-picker
      :value="value"
      @input="pickDate"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'BenefitDateField',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    errorMessages: {
      type: [Array, String],
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    hint: {
      type: String,
      default: 'Формат: YYYY-MM-DD',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuOpen: false,
    }
  },
  methods: {
    pickDate(val) {
      this.$emit('input', val)
      this.menuOpen = false
    },
  },
}
</script>
